import { render, staticRenderFns } from "./GradoPage.vue?vue&type=template&id=4d0e7aa5"
import script from "./GradoPage.js?vue&type=script&lang=js&external"
export * from "./GradoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports